import React, { useCallback } from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';
import { InputFormProps as Props } from 'src/constants/Interface';

const InputForm = ({ ...props }: Props) => {
  const {
    isError,
    inputType,
    inputValue,
    placeholder,
    onChange,
    onBlur,
    isDisabeld,
    autoComplete,
    min,
    max,
  } = props;

  const wrapOnBlur = useCallback(() => {
    if (onBlur) {
      onBlur();
    }
  }, [onBlur]);

  return (
    <Container isError={isError}>
      <input
        type={inputType}
        value={inputValue}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        onBlur={wrapOnBlur}
        disabled={isDisabeld}
        autoComplete={autoComplete}
        min={min}
        max={max}
      ></input>
    </Container>
  );
};

const Container = styled.div<{ isError: boolean }>`
  box-sizing: border-box;
  > input {
    width: 100%;
    border: 2px solid
      ${({ isError }) => (isError ? StyleConfig.COLOR.SECONDORY : StyleConfig.COLOR.INPUT_BORDER)};
    border-radius: 4px;
    background-color: ${({ isError }) => (isError ? 'rgba(255, 3, 3, 0.1)' : '#fff')};
    padding: 12px;
    color: #000;
    font-size: 16px;
    line-height: 1;
    height: 52px;
    &::place-holder {
      color: #919191;
    }
    &[disabled] {
      background-color: ${StyleConfig.COLOR.INPUT_BORDER};
      cursor: not-allowed;
    }
  }
`;

export default InputForm;
